import { Table } from '../../../../components/Table';
import { TableEmptyState } from '../../../../components/TableEmptyState';
import type { Technology } from '../../../../domain/technology';
import { useDispatchTrackEventWithLocation } from '../../../../services/tracking/hooks/useDispatchTrackEventWithLocation';
import { TechnologiesTableRow } from '../TechnologiesTableRow';

const TECHNOLOGIES_TABLE_HEADER_CONFIG = [
  { translateKey: 'company.technologies.table.heading' },
  { translateKey: 'company.technologies.table.date', width: '80px' },
];

export const TechnologiesTable = ({
  technologies,
  filteredTechnologies,
}: {
  technologies: Technology[] | undefined;
  filteredTechnologies: Technology[];
}) => {
  const dispatchTrackEventWithLocation = useDispatchTrackEventWithLocation();

  const onPageChange = (page: number) => {
    dispatchTrackEventWithLocation(
      'technographics',
      'change page',
      `tech results/${filteredTechnologies.length}/${page}`
    );
  };

  if (technologies?.length === 0) {
    return <TableEmptyState view="noResults" />;
  }

  return (
    <>
      {filteredTechnologies.length === 0 ? (
        <TableEmptyState view="noFilteredResults" />
      ) : (
        <Table
          keyProperty="technologyId"
          data={filteredTechnologies}
          headerConfig={TECHNOLOGIES_TABLE_HEADER_CONFIG}
          RowComponent={TechnologiesTableRow}
          onPageChange={onPageChange}
        />
      )}
    </>
  );
};
